<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Processing... </p></ngx-spinner>
 <app-customer-search (searchCustomer)="searchCustomer($event)"></app-customer-search>
 <!-- <div class="row">
   <div class="col-sm-6">

   </div>
   <mat-spinner mode="indeterminate" diameter="40" *ngIf="showSpinner"></mat-spinner>
 </div> -->
 
  <div class="card text-center" >
    <div class="card-header bg-primary text-left text-white font-weight-bold">
      Upload Customer Rank
    </div>
    <div class="card-body mat-card">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group row text-left">
            <label for="lblOffice" class="col-sm-4 col-form-label">Choose file<span
                class="font-red-flamingo">*</span></label>
                <div class="col-sm-8">
                  <div class="input-group">
                      <div class="custom-file">
                          <input type="file" #file placeholder="Choose file" class="custom-file-input" (change)="changePP($event)"  name="inputGroupFile01" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" >
                        <!-- <input type="file" class="custom-file-input" (change)="changePO($event)" name="inputGroupFile01" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01"> -->
                        <label class="custom-file-label" for="inputGroupFile01">{{selectedPPFileName}}</label>
                      </div>
                    </div>
          </div>
        </div>
        
        </div>
        
      </div>
       
      </div>
      <div class="card-footer text-left">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-6">
          
            <div class="form-group row">
              
              <div class="col-sm-10">
                <button type="button" [disabled]="Enable" class="btn btn-primary" (click)="uploadFile(file.files)">Upload File</button>
                <!-- <button type="button" class="btn btn-primary" (click)="formSubmit()">Submit</button> -->
              </div>
            </div>
          </div>
        </div>